import { Injectable } from '@angular/core';

@Injectable()
export class GridLayoutService {
  private placeholderImageWidth = 400;
  private placeholderImageHeight = 225;
  private defaultTargetHeight = 200;

  public itemContainerStyles(
    width = this.placeholderImageWidth,
    height = this.placeholderImageHeight,
    targetHeight = this.defaultTargetHeight
  ) {
    return {
      'width.px': width * targetHeight / height,
      'flex-grow': width / height,
    };
  }

  public itemModalContainerStyles(
    width = this.placeholderImageWidth,
    height = this.placeholderImageHeight,
    targetHeight = this.defaultTargetHeight
  ) {
    return {
      'width.px': width * targetHeight / height,
    };
  }

  public itemRenderedWidth(
    width = this.placeholderImageWidth,
    height = this.placeholderImageHeight,
    targetHeight = this.defaultTargetHeight
  ): number {
    return  width * targetHeight / height;
  }

  public itemChildStyles(
    width = this.placeholderImageWidth,
    height = this.placeholderImageHeight,
  ) {
    return { 'padding-bottom.%': height / width * 100 };
  }
}
